import * as Mui from "@material-ui/core";

const ContainerPaddingBottom = Mui.styled(Mui.Container)(({ theme }) => ({
  padding: theme.spacing(0),
  paddingBottom: theme.spacing(7)
}));

export default ContainerPaddingBottom;
